import * as React from "react";
import {
  CheckboxProvider as UICheckboxProvider,
  CheckboxProviderProps,
} from "@stemscopes/ui";
import InputError from "../../input-error";
import { formHooks } from "../../../form/duck";

const CheckboxProvider: React.FC<CheckboxProviderProps> = ({
  name,
  children,
  ...props
}) => {
  const [field, { error }] = formHooks.useField<boolean>({ name });

  return (
    <>
      {/* eslint-disable-next-line */}
      {/*
      // @ts-ignore */}
      <UICheckboxProvider {...props} {...field}>
        {children}
      </UICheckboxProvider>
      <InputError error={error} />
    </>
  );
};

export default CheckboxProvider;
